import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-customRed text-white p-4 mt-auto text-center">
      <p className="text-customGray">
        &copy; 2024 <Link to="/">Escavatori Rent</Link>. Tutti i diritti
        riservati.
      </p>
      <div className="mt-2">
        <Link to="/privacy-policy" className="text-white mr-4">
          Privacy Policy
        </Link>
        <Link to="/cookie-policy" className="text-white mr-4">
          Cookie Policy
        </Link>
        <Link to="/terms-and-conditions" className="text-white">
          Termini e Condizioni
        </Link>
        <br />
        <p className="text-black">
          Foto di{" "}
          <a href="https://unsplash.com/it/@dominik_photography?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">
            Dominik Vanyi
          </a>
          e di{" "}
          <a href="https://unsplash.com/it/@mattseymour?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">
            Matt Seymour
          </a>{" "}
        
           su{" "}
          <a href="https://unsplash.com/it/foto/una-gru-si-staglia-contro-un-cielo-al-tramonto-NcaCW22qmh4?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">
            Unsplash
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
